import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { useContext, useRef, useReducer } from 'react';
import { useIsomorphicLayoutEffect } from './utils';
import { STATE_CONTEXT_PROPERTY, VERSION_CONTEXT_PROPERTY, SUBSCRIBE_CONTEXT_PROPERTY } from './createProvider';
var EQUALITY_FN_PROPERTY = 'e';
var SELECTOR_PROPERTY = 'r';
var STATE_PROPERTY = 's';
var SELECTED_PROPERTY = 'l';

var defaultEqualityFn = function defaultEqualityFn(a, b) {
  return a === b;
};

export var createUseSelector = function createUseSelector(context) {
  var useSelector = function useSelector(selector) {
    var equalityFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityFn;

    var _useContext = useContext(context),
        state = _useContext[STATE_CONTEXT_PROPERTY],
        version = _useContext[VERSION_CONTEXT_PROPERTY],
        subscribe = _useContext[SUBSCRIBE_CONTEXT_PROPERTY];

    var selected = selector(state);
    var ref = useRef();
    useIsomorphicLayoutEffect(function () {
      var _ref$current;

      ref.current = (_ref$current = {}, _defineProperty(_ref$current, EQUALITY_FN_PROPERTY, equalityFn), _defineProperty(_ref$current, SELECTOR_PROPERTY, selector), _defineProperty(_ref$current, STATE_PROPERTY, state), _defineProperty(_ref$current, SELECTED_PROPERTY, selected), _ref$current);
    });

    var _useReducer = useReducer(function (c, v) {
      if (version < v) {
        return c + 1; // schedule update
      }

      try {
        var refCurrent = ref.current;

        if (refCurrent[STATE_PROPERTY] === state || refCurrent[EQUALITY_FN_PROPERTY](refCurrent[SELECTED_PROPERTY], refCurrent[SELECTOR_PROPERTY](state))) {
          // not changed
          return c; // bail out
        }
      } catch (e) {// ignored (stale props or some other reason)
      }

      return c + 1;
    }, 0),
        _useReducer2 = _slicedToArray(_useReducer, 2),
        checkUpdate = _useReducer2[1];

    useIsomorphicLayoutEffect(function () {
      var callback = function callback(nextVersion, nextState) {
        try {
          var refCurrent = ref.current;

          if (nextState && (refCurrent[STATE_PROPERTY] === nextState || refCurrent[EQUALITY_FN_PROPERTY](refCurrent[SELECTED_PROPERTY], refCurrent[SELECTOR_PROPERTY](nextState)))) {
            // not changed
            return;
          }
        } catch (e) {// ignored (stale props or some other reason)
        }

        checkUpdate(nextVersion);
      };

      var unsubscribe = subscribe(callback);
      return unsubscribe;
    }, [subscribe]);
    return selected;
  };

  return useSelector;
};